export default __webpack_public_path__ + "static/media/bg-for-hex.ca40d861.png";